(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lamseti-new"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('lamseti-carousel')){
    customElements.define('lamseti-carousel', class extends HTMLElement{
      connectedCallback(){
        this.track=this.querySelector('[data-track]');
        this.slides=[...this.querySelectorAll('[data-slide]')];
        this.prevButtons=this.querySelectorAll('[data-prev]');
        this.nextButtons=this.querySelectorAll('[data-next]');
        this.dotsBox=this.querySelector('[data-dots]');
        this.drawer=this.querySelector('[data-cart-drawer]');
        
        if(!this.track||this.slides.length<1)return;
        
        this.prevButtons.forEach(button=>button.addEventListener('click',()=>this.move(-1)));
        this.nextButtons.forEach(button=>button.addEventListener('click',()=>this.move(1)));
        this.track.addEventListener('scroll',()=>this.onScroll(),{passive:true});
        this.addEventListener('keydown',event=>{
          if(event.key==='ArrowRight')this.move(document.dir==='rtl'?-1:1);
          if(event.key==='ArrowLeft')this.move(document.dir==='rtl'?-1:1);
        });
        
        this.buildDots();
        this.onScroll();
        
        if(this.dataset.autoplay==='true'){
          this.start();
          if(this.dataset.pauseHover==='true'){
            this.addEventListener('mouseenter',()=>this.stop());
            this.addEventListener('mouseleave',()=>this.start());
          }
        }

        this.initDrawerEvents();
        this.initAjaxCart();
      }

      initDrawerEvents(){
        if(!this.drawer)return;
        this.querySelectorAll('[data-cart-close]').forEach(el=>{
          el.addEventListener('click',()=>this.closeCartDrawer());
        });
      }

      openCartDrawer(){
        if(this.drawer) this.drawer.classList.add('is-open');
      }

      closeCartDrawer(){
        if(this.drawer) this.drawer.classList.remove('is-open');
      }

      async updateCartDrawerContent(){
        try {
          const res = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await res.json();
          
          document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
          const itemsContainer = this.querySelector('[data-cart-items-container]');
          const footerContainer = this.querySelector('[data-cart-footer]');
          if(cart.items.length === 0){
            itemsContainer.innerHTML = `<p style="text-align:center;margin-top:40px;opacity:0.6;">${document.documentElement.lang === 'ar' ? 'سلة التسوق فارغة' : 'Your cart is empty'}</p>`;
            footerContainer.innerHTML = '';
            return;
          }

          let html = '';
          cart.items.forEach((item, index) => {
            const itemImg = item.image ? item.image : '';
            html += `
              <div class="lamseti-cart-item">
                ${itemImg ? `<img src="${itemImg}" alt="${item.product_title}">` : ''}
                <div class="lamseti-cart-item__info">
                  <a href="${item.url}" class="lamseti-cart-item__title">${item.product_title}</a>
                  <div class="lamseti-cart-item__price">${Shopify.formatMoney ? Shopify.formatMoney(item.final_line_price, window.money_format || '') : (item.final_line_price / 100).toFixed(2) + ' KWD'}</div>
                  <div class="lamseti-cart-item__qty">
                    <button type="button" data-cart-qty-update="${index + 1}" data-new-qty="${item.quantity - 1}">-</button>
                    <span>${item.quantity}</span>
                    <button type="button" data-cart-qty-update="${index + 1}" data-new-qty="${item.quantity + 1}">+</button>
                  </div>
                  <button type="button" class="lamseti-cart-item__remove" data-cart-remove="${index + 1}">${document.documentElement.lang === 'ar' ? 'إزالة' : 'Remove'}</button>
                </div>
              </div>
            `;
          });
          itemsContainer.innerHTML = html;

          const checkoutText = document.documentElement.lang === 'ar' ? 'إتمام الشراء' : 'Checkout';
          const subtotalText = document.documentElement.lang === 'ar' ? 'المجموع الفرعي' : 'Subtotal';
          
          footerContainer.innerHTML = `
            <div class="lamseti-cart-subtotal">
              <span>${subtotalText}</span>
              <span>${Shopify.formatMoney ? Shopify.formatMoney(cart.total_price, window.money_format || '') : (cart.total_price / 100).toFixed(2) + ' KWD'}</span>
            </div>
            <a href="${window.Shopify.routes.root}checkout" class="lamseti-cart-checkout">${checkoutText}</a>
          `;

          itemsContainer.querySelectorAll('[data-cart-qty-update]').forEach(btn => {
            btn.addEventListener('click', async (e) => {
              const line = parseInt(e.target.getAttribute('data-cart-qty-update'));
              const qty = parseInt(e.target.getAttribute('data-new-qty'));
              await this.changeCartQuantity(line, qty);
            });
          });

          itemsContainer.querySelectorAll('[data-cart-remove]').forEach(btn => {
            btn.addEventListener('click', async (e) => {
              const line = parseInt(e.target.getAttribute('data-cart-remove'));
              await this.changeCartQuantity(line, 0);
            });
          });

        } catch(err) {
          console.error('Error fetching cart data:', err);
        }
      }

      async changeCartQuantity(line, quantity){
        try {
          await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: quantity })
          });
          await this.updateCartDrawerContent();
        } catch(err) {
          console.error('Error updating quantity:', err);
        }
      }

      initAjaxCart() {
        this.addEventListener('submit', async (event) => {
          const form = event.target;
          if (!form.matches('form[action*="/cart/add"]') && !form.action.includes('/cart/add')) return;
          
          event.preventDefault();
          const submitButton = form.querySelector('[type="submit"]');
          if (submitButton) submitButton.setAttribute('aria-busy', 'true');

          try {
            const formData = new FormData(form);
            await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              body: formData
            });
            
            await this.updateCartDrawerContent();
            this.openCartDrawer();

            document.dispatchEvent(new CustomEvent('theme:cart:update'));
          } catch (error) {
            console.error('Error adding to cart via AJAX:', error);
            form.submit();
          } finally {
            if (submitButton) submitButton.removeAttribute('aria-busy');
          }
        });
      }

      visible(){
        const style=getComputedStyle(this);
        if(innerWidth<750)return Number(style.getPropertyValue('--ln-cols-mobile'));
        if(innerWidth<990)return Number(style.getPropertyValue('--ln-cols-tablet'));
        return Number(style.getPropertyValue('--ln-cols'));
      }
      step(){return this.slides[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap||0)}
      move(direction){
        const max=this.track.scrollWidth-this.track.clientWidth;
        const next=this.track.scrollLeft+direction*this.step();
        if(this.dataset.loop==='true'){
          if(direction>0&&Math.abs(this.track.scrollLeft)>=max-4){
            this.track.scrollTo({left:0,behavior:'smooth'});
            return;
          }
          if(direction<0&&Math.abs(this.track.scrollLeft)<=4){
            this.track.scrollTo({left:document.dir==='rtl'?-max:max,behavior:'smooth'});
            return;
          }
        }
        this.track.scrollBy({left:direction*this.step(),behavior:'smooth'});
      }
      pages(){return Math.max(1,Math.ceil(this.slides.length/Math.max(1,this.visible())))}
      buildDots(){
        if(!this.dotsBox)return;
        this.dotsBox.innerHTML='';
        for(let index=0;index<this.pages();index++){
          const dot=document.createElement('button');
          dot.type='button';
          dot.className='lamseti-new__dot';
          dot.setAttribute('aria-label',String(index+1));
          dot.addEventListener('click',()=>this.track.scrollTo({left:(document.dir==='rtl'?-1:1)*index*this.step()*this.visible(),behavior:'smooth'}));
          this.dotsBox.append(dot);
        }
      }
      onScroll(){
        const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
        const position=Math.abs(this.track.scrollLeft);
        const page=Math.round(position/Math.max(1,this.step()*this.visible()));
        this.querySelectorAll('.lamseti-new__dot').forEach((dot,index)=>dot.classList.toggle('is-active',index===page));
        if(this.dataset.loop!=='true'){
          this.prevButtons.forEach(button=>button.disabled=position<4);
          this.nextButtons.forEach(button=>button.disabled=position>max-4);
        }
      }
      start(){
        this.stop();
        this.timer=setInterval(()=>this.move(1),Math.max(2000,Number(this.dataset.delay)||5000));
      }
      stop(){if(this.timer)clearInterval(this.timer)}
      disconnectedCallback(){this.stop()}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"] && !Shopify.designMode) return;
  try {
    
  class NewHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-lnh-drawer]');
      this.openButton = this.querySelector('[data-lnh-open]');
      this.closeButton = this.querySelector('[data-lnh-close]');
      this.openButton?.addEventListener('click', this.openDrawer);
      this.closeButton?.addEventListener('click', this.closeDrawer);
      this.drawer?.addEventListener('click', this.onDrawerClick);
      this.drawer?.addEventListener('close', this.onDrawerClose);
      this.querySelectorAll('[data-lnh-localization]').forEach((select) => {
        select.addEventListener('change', () => select.form?.submit());
      });
      this.searchControllers = [];
      this.querySelectorAll('[data-lnh-search-form]').forEach((form) => this.setupPredictiveSearch(form));
      this.lastScrollPosition = window.scrollY;
      this.scrollTicking = false;
      if (this.dataset.stickyMode === 'scroll-up') window.addEventListener('scroll', this.onScroll, { passive: true });
    }
    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.openDrawer);
      this.closeButton?.removeEventListener('click', this.closeDrawer);
      this.drawer?.removeEventListener('click', this.onDrawerClick);
      this.drawer?.removeEventListener('close', this.onDrawerClose);
      window.removeEventListener('scroll', this.onScroll);
    }
    openDrawer = () => {
      this.drawer?.showModal();
      this.openButton?.setAttribute('aria-expanded', 'true');
    };
    closeDrawer = () => this.drawer?.close();
    onDrawerClose = () => this.openButton?.setAttribute('aria-expanded', 'false');
    onDrawerClick = (event) => {
      if (event.target === this.drawer) this.closeDrawer();
    };
    onScroll = () => {
      if (this.scrollTicking) return;
      this.scrollTicking = true;
      window.requestAnimationFrame(() => {
        const currentPosition = window.scrollY;
        const scrollingDown = currentPosition > this.lastScrollPosition;
        const pastHeader = currentPosition > this.offsetHeight + 24;
        this.classList.toggle('lnh--scroll-hidden', scrollingDown && pastHeader && !this.drawer?.open);
        this.lastScrollPosition = Math.max(currentPosition, 0);
        this.scrollTicking = false;
      });
    };
    setupPredictiveSearch(form) {
      const input = form.querySelector('[data-lnh-search-input]');
      const results = form.querySelector('[data-lnh-suggestions]');
      if (!input || !results) return;
      let timer;
      let controller;
      input.addEventListener('input', () => {
        clearTimeout(timer);
        controller?.abort();
        const query = input.value.trim();
        const minimumCharacters = Number(this.dataset.searchMinChars || 1);
        const resultLimit = Number(this.dataset.searchLimit || 6);
        if (query.length < minimumCharacters) {
          this.closeSuggestions(input, results);
          return;
        }
        timer = window.setTimeout(async () => {
          controller = new AbortController();
          try {
            const root = window.Shopify?.routes?.root || '/';
            const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${resultLimit}&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`;
            const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Predictive search request failed');
            const data = await response.json();
            this.renderSuggestions(data.resources?.results?.products || [], input, results);
          } catch (error) {
            if (error.name !== 'AbortError') this.closeSuggestions(input, results);
          }
        }, 220);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeSuggestions(input, results);
      });
      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) this.closeSuggestions(input, results);
      });
    }
    renderSuggestions(products, input, results) {
      results.replaceChildren();
      if (!products.length) {
        const empty = document.createElement('span');
        empty.className = 'lnh__suggestion-empty';
        empty.textContent = input.value;
        results.append(empty);
      } else {
        products.forEach((product) => {
          const link = document.createElement('a');
          link.className = 'lnh__suggestion';
          link.href = product.url;
          link.setAttribute('role', 'option');
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            image.loading = 'lazy';
            link.append(image);
          } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'lnh__suggestion-image';
            link.append(placeholder);
          }
          const content = document.createElement('span');
          const title = document.createElement('span');
          title.className = 'lnh__suggestion-title';
          title.textContent = product.title;
          content.append(title);
          if (product.price) {
            const price = document.createElement('span');
            price.className = 'lnh__suggestion-price';
            price.textContent = product.price;
            content.append(price);
          }
          link.append(content);
          results.append(link);
        });
      }
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    closeSuggestions(input, results) {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }
  }
  if (!customElements.get('new-header')) customElements.define('new-header', NewHeader);

  } catch(e) { console.error(e); }
})();
})();
